import * as React from "react";
import { Spin } from "antd";
import { CustomModal } from "../common/CustomModal";
import { ChangePasswordForm } from "./ChangePasswordForm";

export class ChangePassowordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
    };
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    // this.props.onClose();
  }

  render() {

    const {itemId, Token} = this.props;
    console.log("ITEM: ", Token)

    return (
      <CustomModal
        width="1000px"
        closable={this.state.closable}
        visible={this.state.visible}
        title="Change Password"
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose={true}
        maskClosable={false}
      >
        {this.state.isLoading ? (
          <div style={{ justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <ChangePasswordForm
            data={this.props.item}
            onSubmit={this.props.onChangePassword}
            handleCancel={this.handleCancel}
            Token={this.props.Token}
            itemId={this.props.itemId}
          />
        )}
      </CustomModal>
    );
  }
}
